import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
import { MicroCredentialCard } from '@holmescorp/card';
import { contentTrack, createNlsMiddleware, keymap, pathmap, userstate } from '@holmescorp/lcc-state';
import css from '../css/study.m.css';
import { MicroCardButton } from './card-button';
import { ContentContainer } from './container';
import { MicroProgress } from './progress';
const factory = create({
    theme,
    contentTrack,
    userstate,
    ditabookNls: createNlsMiddleware('ditabook')
}).properties();
export const MicroCard = factory(({ id, properties, middleware: { theme, contentTrack, userstate, ditabookNls } }) => {
    const { topic, root, onAction } = properties();
    const fixedCss = theme.classes(css);
    const { messages: { get_started = '[ditabook] get_started', card_button_label_middle: continue_label = '[ditabook] card_button_label_middle', card_button_label_finished: completed_label = '[ditabook] card_button_label_finished' } } = ditabookNls();
    const key = topic.attributes?.key || '';
    const { path } = keymap.get(key);
    const { view } = pathmap.get(path);
    const { tracked } = contentTrack;
    const tracking = tracked.content[root].filter((t) => t.topicset === key)[0];
    const { isactive, title, completed } = tracking;
    const topicgroups = topic.children?.filter((child) => 'topicgroup' in child) || [];
    const readTime = topicgroups.reduce((acc, child) => {
        const time = child.topicgroup.attributes?.readtime || 0;
        return acc + time;
    }, 0);
    const status = userstate.get(userstate.path('status'));
    const totalComplete = topicgroups.reduce((count, child) => {
        const topicdata = status[child.topicgroup.attributes?.key || ''];
        if (topicdata.data.complete == topicdata.data.total) {
            count += 1;
        }
        return count;
    }, 0);
    return v('div', {
        id,
        classes: [theme.variant()]
    }, [
        w(ContentContainer, { tabIndex: 0, additionalClasses: [fixedCss.card] }, [
            w(MicroCredentialCard, { xqa: `${key}-card` }, [
                {
                    leading: v('div', { classes: [fixedCss.leading] }, [
                        v('img', {
                            title,
                            src: `${window.hcstatic.portal_cdn}/js/images/${window.hcstatic.portal_site}/icons/icon_${key}.png`
                        })
                    ]),
                    trailing: v('div', { classes: [fixedCss.trailing] }, [
                        v('div', { classes: [fixedCss.alphaHalfBlack, fixedCss.basefont], xqa: 'estimated-read-time' }, [`${readTime} minutes`]),
                        v('div', { classes: [fixedCss.titlefont], xqa: 'progress-area-title' }, [title]),
                        w(MicroProgress, { value: totalComplete, min: 0, max: topicgroups.length })
                    ]),
                    actions: v('div', { classes: [fixedCss.actions] }, [
                        w(MicroCardButton, {
                            key: `card-button-${key}`,
                            labelText: completed ? completed_label : isactive ? continue_label : get_started,
                            darkMode: !completed,
                            onClick: () => {
                                onAction && onAction();
                                view();
                            },
                            onDown: () => {
                                onAction && onAction();
                                view();
                            }
                        })
                    ])
                }
            ])
        ])
    ]);
});
export default MicroCard;
